export default __webpack_public_path__ + "static/media/pumperModel.bcbf6462.png";